const getCSSVariable = variable => {
  const value = getComputedStyle(document.documentElement).getPropertyValue(variable);

  return value || null;
};

export { getCSSVariable };
export default getCSSVariable;
